export const paymentMethods = {
  credit_card: 'cartão de crédito',
  boleto: 'boleto',
  pix: 'pix'
};
